export const PAYMENTS_API_URL = 'ui/organization/payments';

export const paymentsQueryKeys = {
  all: [PAYMENTS_API_URL],
};
